import { render, staticRenderFns } from "./SyncRun.vue?vue&type=template&id=dfb9461a&scoped=true&lang=pug"
import script from "./SyncRun.vue?vue&type=script&lang=js"
export * from "./SyncRun.vue?vue&type=script&lang=js"
import style0 from "./SyncRun.vue?vue&type=style&index=0&id=dfb9461a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb9461a",
  null
  
)

export default component.exports